import React from "react";

const FitCategoryCell = ({ value }) => {
  let color = "#43A047"; // green for EXACT FIT
  if (value === "LESS OPTIMUM FIT") {
    color = "#FF7043"; // orange for LESS OPTIMUM FIT
  } else if (value === "PARTIAL FIT") {
    color = "#FFC107"; // amber for PARTIAL FIT
  } else if (value === "UNFIT") {
    color = "#E53935"; // red for UNFIT
  }
  return <span style={{ color, fontWeight: "bold" }}>{value}</span>;
};

export default FitCategoryCell;
